// Minimal entry for index.html packaged by Webpack
// Packaging-only phase: no app logic changes.
import he from 'he';
if (typeof window !== 'undefined') {
  // Expose for legacy code expecting global `he`
  // This preserves behavior after removing the CDN script tag.
  window.he = he;
}
console.log('StockStorm: index bundle loaded');
